module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iUiNT"))).then(() => parcelRequire('ikE14'));